export default __webpack_public_path__ + "static/media/types.a9e4e126.png";